import gql from 'graphql-tag';

export { CREATE_CLIENT } from './createClient';

export const GET_CLIENTS_FOR_SELECTOR = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: ClientPageFilter
	) {
		getClients(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
			}
			count
		}
	}
`;

const CLIENT_MERGE_PREVIEW_CLIENT_FRAGMENT = gql`
	fragment clientMergePreviewClient on ClientMergePreviewClient {
		id
		name
		managerName
		primaryContactName
		secondaryContactName
		address
		priceBookNames
		commissionName
		commissionRate
		locationCount
		pointOfSaleCount
		soldProductCount
		soldProductValue
	}
`;

export const GET_CLIENT_MERGE_PREVIEW = gql`
	query getClientMergePreview($sourceClientId: ID!, $targetClientId: ID!) {
		getClientMergePreview(
			sourceClientId: $sourceClientId,
			targetClientId: $targetClientId
		) {
			sourceClient {
				...clientMergePreviewClient
			}
			targetClient {
				...clientMergePreviewClient
			}
			resultLocationCount
			resultPointOfSaleCount
			resultSoldProductCount
			resultSoldProductValue
			otherRecordsToMove
			warnings
			blockers
			isReady
			resumesInterruptedMerge
		}
	}
	${CLIENT_MERGE_PREVIEW_CLIENT_FRAGMENT}
`;

export const MERGE_CLIENT = gql`
	mutation mergeClient($sourceClientId: ID!, $targetClientId: ID!) {
		mergeClient(
			sourceClientId: $sourceClientId,
			targetClientId: $targetClientId
		) {
			id
			name
		}
	}
`;
